<!------------ START TEMPLATE ------------>
<template>
  <div class="mb-6">
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="filtroConsolidado vx-row p-4">
        <div class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Selecione um período:</span>
          <div class="vx-col gerar sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <datepicker
                :minimumView="'month'"
                :maximumView="'year'"
                icon="icon-arrow-right"
                class="w-full sm:mb-0 mb-3"
                calendar-class="classeDoCalendario"
                label-placeholder="Período"
                name="Período"
                id="Mês"
                input-class="inputData w-full large"
                :format="'MM/yyyy'"
                label="MM/YYYY"
                :language="languages['ptBR']"
                v-model="form.month"
                :disabledDates="{from: new Date()}"
              ><p slot="beforeCalendarHeader" class="pt-2 text-center">
                Mês
              </p></datepicker
              >
            </div>
          </div>
        </div>
        <div v-if="canViewAll" class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Selecione um convênio:</span>
          <div class="vx-col gap-4 sm:flex w-full mt-2">

            <v-select
              clearable
              multiple
              class="w-full lg:mb-0 mb-3"
              placeholder="Buscar por Convênio"
              :options="covenantOptions"
              name="consultancy"
              id="consultancy"
              v-model="form.covenants"
              :closeOnSelect="false"
              @input="searchBrokers()"
            >
              <template #no-options="{ search, searching, loading }">
                <div class="text-center">Nenhum resultado</div>
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="canViewAllConsultancies" class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Selecione uma assessoria:</span>
          <div class="vx-col gap-4 sm:flex w-full mt-2">

            <v-select
              clearable
              multiple
              class="w-full lg:mb-0 mb-3"
              placeholder="Buscar por Assessoria"
              :options="consultancyOptions"
              name="consultancy"
              id="consultancy"
              v-model="form.consultancies"
              :closeOnSelect="false"
              @input="searchBrokers()"
            >
              <template #no-options="{ search, searching, loading }">
                <div class="text-center">Nenhum resultado</div>
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="canViewAllBrokers" class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Selecione uma corretora:</span>
          <div class="vx-col gap-4 sm:flex w-full mt-2">
            <v-select
              clearable
              multiple
              class="w-full sm:mb-0 mb-3"
              :options="brokerOptions"
              placeholder="Buscar por Corretora"
              name="broker"
              id="broker"
              :closeOnSelect="false"
              v-model="form.brokers"
            >
              <template #no-options>
                Nenhum resultado, por favor selecione uma assessoria
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <vs-row vs-align="flex-end" vs-justify="flex-end" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="flex justify-end">
            <vs-button
              :disabled="
                !$can('Leitura carteira corretora', 'Uso da Conta Corrente')
              "
              color="#038803"
              type="border"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-2 mt-2 mr-3 sm:mt-0"
              @click="exportReport()"
            >Exportar
            </vs-button>

            <vs-button
              :disabled="
                !$can('Leitura carteira corretora', 'Uso da Conta Corrente')
              "
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-arrow-right"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-2 mt-2 sm:mt-0"
              native-type="submit"
            >Gerar
            </vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import reportsApi from '../../services/reports.api';

export default {
  name: 'CurrentAccountFilter',
  components: {
    Datepicker,
    'v-select': vSelect,
  },

  data() {
    return {
      companyId: +localStorage.getItem('idEmpresa'),
      brokerOptions: [],
      consultancyOptions: [],
      covenantOptions: [],
      languages: lang,
      user: service.getLoggedUser(),
      form: {
        month: moment().startOf('month').toDate(),
        brokers: [],
        consultancies: [],
        covenants: [],
      },
    };
  },
  async mounted() {
    await this.searchCovenants();
  },
  computed: {
    canViewAll() {
      return this.$can('Leitura de carteira completa', 'Uso da Conta Corrente')
    },
    canViewAllConsultancies() {
      return this.$can('Leitura de carteira completa', 'Uso da Conta Corrente')
        || this.$can('Leitura de carteira convênio', 'Uso da Conta Corrente');
    },
    canViewAllBrokers() {
      return this.$can('Leitura de carteira completa', 'Uso da Conta Corrente')
        || this.$can('Leitura de carteira convênio', 'Uso da Conta Corrente')
        || this.$can('Leitura de carteira assessoria', 'Uso da Conta Corrente');
    },
    isBrokerUser() {
      return this.user && this.user.id_regional;
    },
    isConsultancyUser() {
      return this.user && this.user.id_divisao;
    },
    isCovenantUser() {
      return this.user && this.user.id_convenio;
    },
  },
  methods: {
    onSubmit() {
      const filters = {
        startDate: moment(this.form.month).startOf('month').format('YYYY-MM-DD'),
        endDate: moment(this.form.month).endOf('month').format('YYYY-MM-DD'),
        brokers: this.form.brokers.map((item) => item.value),
        consultancies: this.form.consultancies.map((item) => item.value),
        covenants: this.form.covenants.map((item) => item.value),
      }
      this.$emit('filter', filters);
    },
    exportReport() {
      const filters = {
        startDate: moment(this.form.month).startOf('month').format('YYYY-MM-DD'),
        endDate: moment(this.form.month).endOf('month').format('YYYY-MM-DD'),
        brokers: this.form.brokers.map((item) => item.value),
        consultancies: this.form.consultancies.map((item) => item.value),
        covenants: this.form.covenants.map((item) => item.value),
      }
      this.$emit('export', filters);
    },
    async searchBrokers() {
      if (this.canViewAll) {
        reportsApi.getAllBrokers(
          this.companyId,
        ).then((response) => {
          this.brokerOptions = response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        })
        return;
      }
      if (!this.canViewAllBrokers && this.isBrokerUser) {
        this.form.brokers = [{value: this.user.id_regional}];
      } else if (this.canViewAllBrokers && this.isBrokerUser) {
        reportsApi.getAllBrokers(
          this.companyId,
        ).then((response) => {
          this.brokerOptions = response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        })
      } else if (this.isConsultancyUser) {
        reportsApi.getConsultancyBrokers(
          this.companyId,
        ).then((response) => {
          this.brokerOptions = response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        })
      } else if (this.isCovenantUser) {
        reportsApi.getCovenantBrokers(
          this.companyId,
        ).then((response) => {
          this.brokerOptions = response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        })
      }
    },
    async searchConsultancies() {
      if (this.canViewAll) {
        reportsApi.getCompanyConsultancies(this.companyId).then((response) => {
          this.consultancyOptions = response.map((item) => {
            return {
              label: item.divisionName,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        });
        await this.searchBrokers()
        return
      }
      if (!this.canViewAllConsultancies && this.isConsultancyUser) {
        this.form.consultancies = [{value: this.user.id_divisao}];
      } else if (this.canViewAllConsultancies && this.isCovenantUser) {
        reportsApi.getCovenantConsultancies(this.companyId).then((response) => {
          this.consultancyOptions = response.map((item) => {
            return {
              label: item.divisionName,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        });
      }
      await this.searchBrokers()
    },
    async searchCovenants() {
      if (!this.canViewAll && this.isCovenantUser) {
        this.form.covenants = [{value: this.user.id_convenio}];
      } else {
        reportsApi.getCompanyCovenants(this.companyId).then((response) => {
          this.covenantOptions = response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }).catch((error) => {
          console.log('Erro ao buscar assesorias componente ', error);
        });
      }
      await this.searchConsultancies()
    },
  }
};
</script>
<!------------ END SCRIPT ------------>
<style>
.labelFiltro {
  font-size: 14px;
  color: black;
}

.filtroConsolidado .vs__dropdown-toggle {
  padding: 7px 0 !important;
  border-radius: 10px;
  font-size: 14px;
}

.filtroConsolidado .vdp-datepicker input {
  width: 100%;
  padding: 1rem 0.7rem;
  border-radius: 10px;
}

.filtersBtn {
  width: 80px;
}

.filtroConsolidado .vdp-datepicker__calendar {
  z-index: 900 !important;
}

.gerar .vs-button {
  border-radius: 14px;
}

.vs__dropdown-menu {
  top: inherit !important;
}
</style>
